

export enum PrincingTypeEnum {
  SUM = 1,
  MAX
}
